import React  from 'react';
import {PaymentProcessor} from "./types.d";
import {usePaymentState} from "../../../hooks/usePaymentState";
import Pay360Container from "./Pay360/Pay360Container";
import StripeWizard from "./Stripe/Wizard";

export function PaymentSetup() {
  const {paymentDetails} = usePaymentState();
  function renderPaymentBasedOnProcessor(){
    const {paymentProcessor} = paymentDetails;
    switch (paymentProcessor) {
      case PaymentProcessor.STRIPE:
        return <StripeWizard/>
      case PaymentProcessor.PAY360:
        return <Pay360Container/>
      //we can add other payment processors here like SQUARE
      // case PaymentProcessor.SQUARE:
      //   return <div></div>
      default:
        return null
    }
  }
  return renderPaymentBasedOnProcessor();
}
